import $ from 'jquery';

/**
 * Get current CSRF token from cookies
 * @returns {string} CSRF token
 */
export function getToken() {
    let token = false;
    document.cookie.split(';').forEach((cookie) => {
        if (cookie.indexOf('csrftoken') >= 0) {
            token = cookie.split('=')[1].trim();
        }
    });

    return token || null;
}

/**
 * Determine if url is from the current origin
 * @param {string} url
 * @returns {boolean}
 */
export function isSameOrigin(url) {
    const { host, protocol } = document.location;
    const srOrigin = `//${host}`;
    const origin = protocol + srOrigin;
    return url === origin
        || url.slice(0, origin.length + 1) === `${origin}/`
        || (url === srOrigin || url.slice(0, srOrigin.length + 1) === `${srOrigin}/`)
        || !(/^(\/\/|http:|https:).*/.test(url));
}

/**
 * Determine is current request method is "safe"
 * @param {string} type - request type. GET, HEAD, etc
 * @returns {boolean}
 */
function safeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

/**
 * Tests request for same origin and unsafe method (i.e. needs header and is cool to get it)
 * @param {string} type - request type. GET, HEAD, etc
 * @param {string} url
 * @returns {boolean}
 */
function needsHeader(type, url) {
    return !safeMethod(type) && isSameOrigin(url);
}

/**
 * Add the CSRF token the request
 * @param {XMLHTTPRequest} xhr
 */
function setHeader(xhr) {
    xhr.setRequestHeader('X-CSRFToken', getToken());
}

// test for csrf needs and set header, if appropriate
$(document).ajaxSend((event, xhr, settings) => {
    if (needsHeader(settings.type, settings.url)) {
        setHeader(xhr);
    }
});
